import { Container, Log, ParamEvent } from '@cgs/wge';
import { RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';
import { ResourcesComponent } from '../resources_component';
import { IFadeReelsProvider } from './i_fade_reels_provider';

export class FadeReelsProvider implements IFadeReelsProvider {
  private _container: Container;

  constructor(container: Container) {
    this._container = container;
  }

  public enableFade(enable: boolean): void {
    const fadeStaticIconsNode =
      this._container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN).fadeStaticIcons;

    if (!fadeStaticIconsNode.length) {
      Log.Error('Fade node not found');
    }

    fadeStaticIconsNode.forEach((fadeNode) => {
      fadeNode.stateMachine?.dispatchEvent(new ParamEvent<string>(enable ? 'anim' : 'default'));
    });
  }
}
